<template>
  <div>
    <div v-if="card_list.length === 0">
      <v-btn color="#6dbe45" large style="width: 130px">
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      </v-btn>
    </div>
    <div class="top" v-else>
      <CartPopup />
      <h4 style="color: white; font-weight: bold; width: 90%; margin: auto">
        Best Container Prices For Delivery To {{ delivery_city }}
      </h4>
      <ul>
        <li v-for="(item, index) in card_list" :key="index" class="grow">
          <div :class="item">
            <v-flex pa-3>
              <v-card
                class="mx-auto pa3"
                color="gray lighten-4"
                style="width: 300px; border-radius: 10px;"
                elevation="20"
                @click.prevent="
                  item.availableForSale
                    ? addedfromlist(
                        item.size,
                        item.image_url,
                        item.size_description,
                        item.market_city
                      )
                    : doNothingatClick()
                "
              >
                <img :src="item.image_url" width="200px" height="200px" />
                <v-card-text class="pt-4" style="position: relative">
                  <h3>{{ item.size_description }}</h3>
                  <p>Starting at ${{ format(item.price) }}</p>
                  <p>Optional Delivery: ${{ format(item.hauling_price) }}</p>
                  <p style="font-size: 15px">
                    Pick-up: $0 ({{ item.market_city }})
                  </p>
                  <div class="unavailable" v-if="!item.availableForSale">
                    <v-btn
                      relative
                      color="#ffffff"
                      class="my-2"
                      medium
                      style="color: #00587d; font-weight: bold"
                      >Out of Stock</v-btn
                    >
                  </div>
                  <div v-else>
                    <v-btn
                      relative
                      color="#00587d"
                      class="my-2 btns"
                      medium
                      style="color: #ffffff"
                      >Select&nbsp;
                      <v-icon small color="#ffffff"
                        >mdi-arrow-right-bold</v-icon
                      ></v-btn
                    >
                  </div>
                  <div v-if="COUNTRY_CODE === 'US'">
                    <h2><span>OR</span></h2>                   
                    <h6 class="animate-charcter" v-if="rto_amounts[index]">
                      Rent to Own as low as $
                      {{ format(rto_amounts[index]) }}/mo
                    </h6>
                    <h6 v-else style="opacity: 0">RTO</h6>
                    <v-btn
                      text
                      class="rto_btn"
                      color="#6dbe45"
                      large
                      style="color: #00587d"
                      :disabled="!item.availableForSale"
                      @click.stop="openRtoModel(item.size)"
                      >Rent to Own&nbsp;
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </div>
        </li>
      </ul>
      <RTOModel ref="rto_model" />
    </div>
    <br />
  </div>
</template>

<script>
import CartPopup from "./FixedComponents/CartPopup.vue";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import { formatNumber } from "@/JS/FormatNumber";
import RTOModel from "./RTO_Model.vue";

export default {
  name: "SelectContainers",
  components: {
    CartPopup,
    RTOModel,
  },
  computed: {
    ...mapGetters({
      containers_list: types.CONTAINER_LIST,
      CART: types.CART_LIST,
      cscTerms: types.CSC_TERMS,
      currentSurvey: types.CURRENTSURVEYOBJECT,
      COUNTRY_CODE: types.COUNTRYCODE,
    }),
  },
  data() {
    return {
      delivery_city: "",
      card_list: [],
      rto_amounts: [],
      scrollHeight: null,
    };
  },
  mounted() {
    //get containers_list from the back-end(sales_price method), if it is null.
    if (this.containers_list) {
      this.delivery_city = this.containers_list.customerInfo.DeliveryCity;
      this.initializelist();
      this.calculateRTOAmountAPI();
    } else this.$router.push("/");
  },
  methods: {
    ...mapActions({
      updateCurrentSurvey: types.ACTIONS_UPDATE_CURRENTSURVEYOBJECT,
      calculateRTOAmount: types.ACTIONS_CALCULATE_RTOAMOUNT,
    }),
    initializelist() {
      const lowest_priced_list = this.containers_list.front_page;
      var indexLowPrice;
      for (indexLowPrice in lowest_priced_list) {
        this.card_list.push(lowest_priced_list[indexLowPrice]);
      }
    },
    doNothingatClick() {
      return;
    },
    addedfromlist(size, image, size_description, market_city) {
      /*add the container user selected to global variable of store called currentSurveyObject
      only save sku as DAL40SC and remove WWT/CWO/OTC
      maintain LocalStorage*/
      //Assign Delivery type based on line item present in the cart
      let delivery_type =
        this.CART.length === 0
          ? "DELIVERY"
          : this.CART[0]["customAttributes"]["Delivery"];
      const currentSurveyObject = {
        oldSku: "",
        formattedSku: size,
        description: size_description,
        delivery: delivery_type,
        type: "NEW",
        cscterms: this.cscTerms,
        purpose: "STORAGE",
        imageurl: image,
        market_city: market_city,
      };

      this.updateCurrentSurvey(currentSurveyObject);
      this.maintainLocalStorageSurveyObject();
      this.$router.push("/purchase/container");
    },
    format(num) {
      return formatNumber(num);
    },
    openRtoModel(size) {
      this.$refs.rto_model.open(size);
    },
    maintainLocalStorageSurveyObject() {
      //Update Local Storage
      const currentSurveyObject = JSON.stringify(this.currentSurvey);
      localStorage.setItem("currentSurveyObject", currentSurveyObject);
    },
    calculateRTOAmountAPI() {
      this.rto_amounts = new Array(this.card_list.length).fill(null);
      setTimeout(() => {
        for (let i = 0; i < this.card_list.length; i++) {
          if (!this.card_list[i].availableForSale) continue;
          this.calculateRTOAmount(
            this.card_list[i].price + this.card_list[i].hauling_price
          ).then((response) => {
            let amounts = response.data.Details;
            amounts.forEach((amount) => {
              if (amount.duration === 48)
                this.$set(this.rto_amounts, i, amount.monthlyPayment);
            });
          });
        }
      }, 200);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Material+Icons");

.top {
  margin: 0px auto;
  width: 90%;
  padding: 10px;
  text-align: center;
}

.btns {
  margin: 35px;
  color: #ffffff;
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  box-shadow: 2px 1px 2px 3px #6dbe45;
}
.rto_btn {
  text-transform: unset !important;
}

.btns i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
}

.btns:hover i {
  max-width: 10rem;
  transition-delay: 0.1s;
}

.v-card p {
  font-size: 20px;
}

li {
  display: inline-block;
}

h3 {
  font-weight: bold;
  font-size: 23px;
}

@media screen and (max-width: 411px) {
  v-card,
  img {
    width: 90%;
  }

  .top {
    width: 100%;
  }
}

h2 {
  margin: 0px auto;
  margin-top: 20px;
  margin-bottom: 25px;
  width: 80%;
  text-align: center;
  border-bottom: 1px solid grey;
  line-height: 0.1em;
  font-size: 14px;
  color: darkgrey;
}

h2 span {
  background: #fff;
  padding: 0 10px;
}

.animate-charcter {
  font-size: 14px;
  font-weight: 700;  
  background: -webkit-linear-gradient(rgb(224, 221, 221), #333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
